'use client'

// Allows inline scripts to execute
import InnerHTML from 'dangerously-set-html-content'

export default function CustomHtml({ html }) {
  return (
    <div className="component component--custom-script">
      <div className="container">
        <InnerHTML html={html} />
      </div>
    </div>
  )
}
